export default __webpack_public_path__ + "static/media/2502102.aadb5864.jpg";